import React, { useEffect, useState } from "react";
import Avatar from '@material-ui/core/Avatar';
import Card from '@mui/material/Card';
import "../../styles/devices/mob_UserProfile.css";
import { useTranslation } from "react-i18next";


export function DialogInfoProfile(props) {

  const { profileData } = props;
  const { t } = useTranslation("global")

  return (
    <>
        <Card>
          <div className='sig_ProfileInfo_Root'>
            <div className='sig_ProfileInfo_MainContainer'>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.isPublic")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['isPublic'] === '' ? '-' : (profileData['isPublic'] ? 'PÚBLICO' : 'PRIVADO') }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.email")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['email'] === '' ? '-' : profileData['email'] }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.sex")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['sex'] === '' ? '-' : profileData['sex']  }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.age")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['age'] === '' ? '-' : profileData['age']  }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.address")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['address'] === '' ? '-' : profileData['address']  }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.level")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['level'] === '' ? '-' : profileData['level']  }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.school")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['school'] === '' ? '-' : profileData['school']  }</div>
              </div>
              <div className='sig_SignModal_PaperLine'>
                  <div className="sig_SignModal_PaperTitle">{t("sProfile.zip_code")}</div>
                  <div className="sig_SignModal_PaperBody">{ profileData['zip_code'] === '' ? '-' : profileData['zip_code']  }</div>
              </div>
              {profileData['arr_teams'].length > 0 && (
                  <div className='sig_SignModal_PaperLine'>
                      <div className="sig_SignModal_PaperTitle"> {t("sProfile.team")} </div>
                      <div className="sig_SignModal_PaperBody">
                          {profileData['arr_teams'].map((team, index) => (
                              <div key={index}>{team}</div>
                          ))}
                      </div>
                  </div>
              )}
            </div>
          </div>
        </Card>
      </>
);
}